import React, { useState, useCallback, useEffect } from 'react';
import ScreenHeader from '../../components/ScreenHeader';
import CourseLessonsItem from './components/CourseLessonsItem';
import { Link, useLocation } from 'react-router-dom';
import { calcCountPages, calcOffset } from '../../../../utils/pagination';
import CoursesService from '../../../../services/CoursesService';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import EmptyResult from '../../../components/EmptyResult';
import SearchBox from '../../../components/SearchBox/SearchBox';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SyllabusScreen(props){
  const coursesLessonsLoading = Array.from(Array(5).keys());
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // pagination
  const location = useLocation();
  let query = useQuery();  
  const [countPages, setCountPages] = useState(0);  
  const page = parseInt(query.get("page")) || 1;  
  const paginationLimit = 5;
  
  const fetchCoursesData = useCallback(async (value) => {
    setIsLoading(true);
    try{
      const result = await CoursesService.listCourses({
        fields: 'id,name,modified_datetime,description,required_books',
        limit: paginationLimit,
        offset: calcOffset(page, paginationLimit),
      }, {name__icontains: value} );
      setCourses(result.data.results);      
      setCountPages(calcCountPages(result, paginationLimit));      
      setIsLoading(false);
    }catch (error) {
      setCourses([]);
    }  
  }, [page]) 
  
  useEffect(() => { 
    // Query Params changued
    fetchCoursesData();
  }, [fetchCoursesData, location.search]);

  return (
    <div id="syllabus-screen" className={`${props.className} dashboard-container`}>
      {/* Header */}
      <ScreenHeader title="Modules">
        {/* <Button
          variant="outlined"
          color="primary"
          endIcon={<AddIcon />}
        > Add course
        </Button> */}
      </ScreenHeader>  

      {/* Body */}
      <div className="content">
        <SearchBox fetchData={fetchCoursesData} placeholder="Search by course" />
        <div className="syllabus-list" style={{ minHeight: '36em'} }>
          {isLoading ? 
            // Generate 5 courses of loading data
            coursesLessonsLoading.map(i => (
              <CourseLessonsItem  key={i} loading/>
            ))
            : 
              // Show courses
              courses.length > 0 ?
                courses.map(course => (
                  <CourseLessonsItem data={course} key={course.id} />
                ))    
              : 
              // Show Empty courses
              <EmptyResult />         
          }        
        </div>
        <Pagination
              page={page}
              count={countPages}
              color="primary" 
              size="large"
              renderItem={item => (
                <PaginationItem
                  component={Link}
                  to={`/dashboard/syllabus${item.page === 1 ? '' : `?page=${item.page}`}`}
                  {...item}
                />
              )}
            />
      </div>
    </div>
  )
}

export default SyllabusScreen;